// import { Icons } from "../../assets/icons";
import { getSection1 } from "../../api/contactPage/section1";
import Footer from "../../components/footer";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useEffect, useState } from "react";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

// import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { useToast } from "../../components/ui/use-toast";
import toasterMessage from "../../components/toasterMessage";
import { Toaster } from "../../components/ui/toaster";
import { ExternalLink } from "lucide-react";
import { Combobox } from "../../components/ui/combobox";
import { sendMailFunction } from "../../api/email/sendMailFunction";
import Events from "./EventsPage";
import RedirectPopup from "../../components/redirectPopup";
// import { SendMailFunction } from "@/api/email/sendMailFunction";

const ContactPage = () => {
  useDocumentTitle("Contact Us");

  countries.registerLocale(enLocale);
  const countryOptions = Object.entries(
    countries.getNames("en", { select: "official" }),
  )
    .sort((a, b) => a[1].localeCompare(b[1]))
    .map(([code, name]) => ({
      label: name,
      value: name,
    }));

  const formFields = [
    {
      name: "country",
      label: "Country",
      placeholder: "Select your country",
      type: "select",
      options: countryOptions,
    },
    {
      name: "howCanWeHelpYou",
      label: "How can we help you?",
      type: "select",
      placeholder: "How can we help you",
      options: [
        { label: "I have a general question", value: "general_question" },
        {
          label: "I am interested in partnering opportunities with ExploR&D",
          value: "member_interest",
        },
      ],
    },
    {
      name: "firstName",
      label: "First Name",
      placeholder: "First Name",
      type: "text",
    },
    {
      name: "lastName",
      label: "Last Name",
      placeholder: "Last Name",
      type: "text",
    },
    {
      name: "company",
      label: "Company",
      placeholder: "Company",
      type: "text",
    },
    {
      name: "title",
      label: "Title",
      placeholder: "Title",
      type: "text",
    },
    {
      name: "email",
      label: "Email For Contact",
      placeholder: "Email",
      type: "email",
    },
    {
      name: "areaOfResearchAndDrugModality",
      label: "Area of research and drug modality",
      placeholder: "Area of research and drug modality",
      type: "text",
    },
    {
      name: "whoYouAre",
      label: "How many employees does your company currently have?",
      type: "select",
      placeholder: "How many employees does your company currently have",
      options: [
        { label: "0-10", value: "0-10" },
        { label: "11-25", value: "11-25" },
        { label: "26-40", value: "26-40" },
        { label: "40+", value: "40+" },
      ],
    },
  ];

  const terms_acceptance = {
    terms_acceptance_text:
      "When you click 'Submit', you certify that you are at least 18 years of age and a global resident and consent to the use of the information provided to allow Lilly and its representatives to provide information and answers to your request. For more information about Lilly's privacy practice, please view the",
    terms_acceptance_privacy_link:
      "https://www.lillyhub.com/legal/lillyusa/english/privacy.html",
    terms_acceptance_privacy_text: "Privacy Statement.",
  };
  const { toast } = useToast();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>();
  const initialFormData = formFields.reduce(
    (acc, field) => {
      acc[field.name] = "";
      return acc;
    },
    {} as Record<string, string>,
  );

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(
    Object.keys(initialFormData).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    ),
  );

  // const [formData, setFormData] = useState({
  //   email: "",
  //   name: "",
  //   typeOfQuestion: "",
  //   whoYouAre: "",
  //   message: "",
  // });
  // const [errors, setErrors] = useState({
  //   email: false,
  //   name: false,
  //   typeOfQuestion: false,
  //   whoYouAre: false,
  //   message: false,
  // });

  const fetchData = () => {
    getSection1().then((res) => {
      setData(res.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSendEmail = async (payload: any) => {
    try {
      const res = await sendMailFunction(payload);
      if (res?.message === "Email sent successfully") {
        setFormData(initialFormData);
        toast(
          toasterMessage(
            "Your response has been recorded. We will get back to you soon!",
          ),
        );
      } else {
        toast(toasterMessage("Unexpected response from server."));
      }
    } catch (error: any) {
      toast(toasterMessage(error.message || "Failed to send email."));
    }
  };

  const handleSubmit = async () => {
    const newErrors = Object.keys(formData).reduce(
      (acc, key) => {
        acc[key] = !formData[key];
        return acc;
      },
      {} as Record<string, boolean>,
    );

    setErrors(newErrors);
    if (Object.values(newErrors).includes(true)) {
      toast(toasterMessage("Please fill all required fields."));
      return;
    }
    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast(toasterMessage("Please enter a valid email address."));
      setErrors((prev) => ({ ...prev, email: true }));
      return;
    }

    // if (formData.country !== "United States of America") {
    //   toast(
    //     toasterMessage(
    //       "Currently we are only accepting responses for United States of America.",
    //     ),
    //   );
    //   setErrors((prev) => ({ ...prev, country: true }));
    //   return;
    // }

    // console.log("Form submitted:", formData);
    const payload = {
      recipientEmail: "explornd_expert_support@lists.lilly.com",
      interestType: formData.howCanWeHelpYou,
      firstName: formData.firstName,
      lastName: formData.lastName,
      company: formData.company,
      title: formData.title,
      email: formData.email,
      researchArea: formData.areaOfResearchAndDrugModality,
      country: formData.country,
      employeesCount: formData.whoYouAre,
    };

    await handleSendEmail(payload);
  };

  return (
    <div className="flex flex-col">
      <div className="md:p-8 p-4 md:px-12">
        <div className="grid grid-cols-8">
          <div className="md:hidden col-span-8 mb-8">
            <div className="relative h-full w-full ">
              {!loading && (
                <img
                  className="rounded-[8px] h-[15rem] w-full object-cover"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data.Image.url}`}
                  alt={data?.Image?.alternativeText ?? "contact page image"}
                />
              )}
              <div className="absolute top-0 left-0 p-4 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                <div className="text-body-text-lilly_red">
                  {!loading && (
                    <img
                      className="h-10 w-10 object-cover"
                      src={`${process.env.REACT_APP_API_BASE_URL}${data.Icon.url}`}
                      alt={data?.Icon?.alternativeText ?? "contact page icon"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="md:text-5xl text-3xl tracking-tighter md:leading-10 leading-8 flex items-center md:col-span-5 col-span-8 -ml-[0.125rem] font-medium">
            <h1>Contact Us</h1>
          </div>

          <div className="m-auto mr-0 md:block hidden">
            <div className="h-20 w-20 p-5 bg-bg-neutral_rose flex items-center justify-center rounded-[8px]">
              {!loading && (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}${data.Icon.url}`}
                  alt={data?.Icon?.alternativeText ?? "contact page icon"}
                />
              )}
            </div>
          </div>

          <div className="md:col-span-2 md:block hidden"></div>
          <div className="md:col-span-5 col-span-8">
            <div className="md:w-3/5 w-full">{!loading && data.Message}</div>

            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-4 mt-12">
              {formFields.map((field, index) => {
                const isError = errors[field.name];
                const commonProps = {
                  id: field.name,
                  value: formData[field.name],
                  onChange: (e: any) => {
                    const value = field.type === "select" ? e : e.target.value;
                    setFormData((prev) => ({ ...prev, [field.name]: value }));
                    setErrors((prev) => ({ ...prev, [field.name]: false }));
                  },
                };

                return (
                  <div
                    key={field.name}
                    className={field.type === "textarea" ? "md:col-span-2" : ""}
                  >
                    <div className="font-bold text-sm my-2">{field.label}</div>

                    {field.name === "country" ? (
                      <Combobox
                        value={formData[field.name]}
                        onChange={(val) => {
                          // if (
                          //   val !== null &&
                          //   val !== undefined &&
                          //   val !== "United States of America"
                          // ) {
                          //   toast(
                          //     toasterMessage(
                          //       "Currently we are only accepting responses for United States of America.",
                          //     ),
                          //   );
                          // }
                          setFormData((prev) => ({
                            ...prev,
                            [field.name]: val,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            [field.name]: false,
                          }));
                        }}
                        options={field.options ?? []}
                        placeholder={field.placeholder}
                        ariaLabel={field.label}
                      />
                    ) : field.type === "select" ? (
                      <Select
                        value={formData[field.name]}
                        onValueChange={commonProps.onChange}
                      >
                        <SelectTrigger
                          className={`border ${
                            isError ? "border-red-500" : "border-border-gray20"
                          } ${
                            formData[field.name]
                              ? "text-body-text"
                              : "text-muted-foreground"
                          }`}
                          aria-label={field.label}
                        >
                          <SelectValue
                            placeholder={field.placeholder}
                            className={
                              !formData[field.name]
                                ? "text-muted-foreground"
                                : ""
                            }
                          />
                        </SelectTrigger>
                        <SelectContent className="w-[var(--radix-select-trigger-width)] max-w-full">
                          {field.options?.map((opt) => (
                            <SelectItem
                              key={opt.value}
                              value={opt.value}
                              className="whitespace-normal break-words text-wrap px-8 py-2 leading-snug relative"
                            >
                              {opt.label}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    ) : (
                      <Input
                        type={field.type}
                        placeholder={field.placeholder}
                        className={`border ${
                          isError ? "border-red-500" : "border-border-gray20"
                        }`}
                        aria-label={field.label}
                        {...commonProps}
                      />
                    )}
                  </div>
                );
              })}
            </div>
            <div className="text-sm justify-center m-auto flex flex-col gap-2 mt-12">
              <div>{terms_acceptance.terms_acceptance_text}</div>
              <div className="text-body-text-lilly_red underline font-medium active:text-body-text-lilly_link_hover cursor-pointer flex items-center gap-2">
                <RedirectPopup
                  link={terms_acceptance.terms_acceptance_privacy_link}
                  target="_blank"
                  className=""
                  aria-label="terms acceptance (opens in new tab)"
                  rel="noreferrer"
                  content={terms_acceptance.terms_acceptance_privacy_text}
                />

                <ExternalLink size={16} />
              </div>
              <div>
                <Button
                  variant="outline"
                  onClick={handleSubmit}
                  className="mt-4"
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
          <div className="col-span-1"></div>
          <div className="md:col-span-2 hidden md:block">
            {!loading && (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}${data?.Image.url}`}
                alt={data?.Image?.alternativeText ?? "contact page image"}
                className="lg:max-h-[32em] max-h-none h-full w-full object-cover rounded-[8px]"
              />
            )}
          </div>
        </div>
      </div>
      <Events />
      <Toaster />
      <Footer />
    </div>
  );
};

export default ContactPage;
